import React from "react";
import { Input, type InputProps } from "antd";
import { useControlledInputValue } from "./UseControlledInputValue";

type StyledPasswordInputProps = InputProps;

const StyledPasswordInput: React.FC<StyledPasswordInputProps> = ({
  className,
  value,
  defaultValue,
  onChange,
  ...props
}) => {
  const controlled = useControlledInputValue(value, defaultValue, onChange);

  return (
    <Input.Password
      {...props}
      value={controlled.value}
      onChange={controlled.onChange}
      className={`styled-text-input ${
        controlled.hasValue ? "styled-text-input--has-value" : ""
      } ${className || ""}`}
    />
  );
};

export default StyledPasswordInput;
